/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper.ts';

export default declareEntity({
    entity: "organisationStatistics",
    graphQL: "OrganisationStatistic",
    name: "Organisation's Statistics",
    dynamoPrefix: 'org',
    storageType: 'central',
    defaultTitle: (data) => {
        return data['name'];
    },
    defaultOrder: ['name'],
    fields: (types) => { return {
        id: {
            name: "Organisation ID",
            type: "id",
            defaultValue: (organisation) => {
                return organisation['id'];
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        lastExtensionUpdate: {
            name: "Updated At",
            type: "datetime",
            userEditable: false,
        },
        lastPanelView: {
            name: "Updated At",
            type: "datetime",
            userEditable: false,
        },
        usedScenarios: {
            name: "Used Scenarios",
            type: "int",
            userEditable: false,
            defaultValue: 0,
        },
        usedApplications: {
            name: "Used Applications",
            type: "int",
            userEditable: false,
            defaultValue: 0,
        },
        usersCount: {
            name: "Users",
            type: "int",
            userEditable: false,
            defaultValue: 0,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
        },
    }; },
    relations: (types) => { return {
    }; }
});
